import { debounce, get, reduce, round, toNumber, toString } from 'lodash'

export const dataFilterTableMixin = {
  data () {
    return {
      filtersD: {},
    }
  },
  watch: {
    filters: {
      handler: debounce(function () {
        this.filtersD = this.filters
      }, 800),
      deep: true,
    },
  },
  computed: {
    filteredItems: function () {
      return this.items.filter(d => {
        return Object.keys(this.filtersD).every(f => {
          try {
            if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
              let filter = this.filtersD[f].data
              if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
              return eval((get(d, f) || '0').toString() + filter)
            }
          } catch (e) {
            return true
          }
          return this.filtersD[f].data.length < 1
            || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
              || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
              || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
              || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
        })
      })
    },
    // filteredTotalRows: function () {
    //   return this.totalRows?.filter?.(d => {
    //     return Object.keys(this.filtersD).every(f => {
    //       if (f != 'currency') {
    //         return true
    //       }
    //       return (this.filtersD[f].data.length < 1 || (this.filtersD[f].data.includes(get(d, f)) || (get(d, f).toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
    //     })
    //   })
    // },
  },
  methods: {}
}
